// Shared constants + pure helpers for the dashboard feature.

export const COUNTRIES = {
  us: [["us", "United States"]],
  eu: [["gb", "United Kingdom"], ["de", "Germany"], ["fr", "France"], ["es", "Spain"], ["it", "Italy"], ["nl", "Netherlands"]],
  cn: [["cn", "China"], ["jp", "Japan"], ["sg", "Singapore"], ["in", "India"], ["au", "Australia"]],
};
export const REGIONS = [["us", "🇺🇸", "Americas"], ["eu", "🇪🇺", "Europe"], ["cn", "🇨🇳", "Asia"]];
// WealthProxies pools. Live list comes from GET /api/pools (partner API); this is the fallback.
export const POOLS = ["general", "core", "walmart", "walmart2", "target", "shopify", "akamai", "pokemoncenter", "outlook"];

// Display-ONLY overrides: key = real gateway token (unchanged in the proxy string), value = label shown on site.
// Renaming here is purely cosmetic and never affects the actual proxy connection string.
export const POOL_LABELS = {
  walmart: "Wally Premium",
  pokemoncenter: "PKC Prime",
  outlook: "Inbox Elite",
  core: "Genesis Core",
  general: "Universal Pool",
  shopify: "Shopify Elite",
  target: "Bullseye Premium",
  akamai: "Akamai Velocity",
};
// Pools to hide from the dropdown (still valid tokens, just not offered to users).
export const POOL_HIDDEN = ["walmart2"];
export const poolLabel = (token) => POOL_LABELS[token] || (token.charAt(0).toUpperCase() + token.slice(1));
// Sticky session types. Prefixes confirmed from real strings: Soft=S, Hard=H; Mixed=M inferred.
export const SESSION_TYPES = [
  ["soft", "SOFT", "Holds the IP, rotates on failure — best default for most sites"],
  ["hard", "HARD", "Locks the same IP for the whole session (checkout / queues)"],
  ["mixed", "MIXED", "Hybrid: sticky with rotating fallback"],
];
export const SESSION_PREFIX = { soft: "S", hard: "H", mixed: "M" };
export const hexId = (n = 11) => Array.from({ length: n }, () => Math.floor(Math.random() * 16).toString(16)).join("");
export const QTY_PRESETS = [100, 1000, 2500, 5000, 10000];
export const GEN_CAP = 10000;

// Pure builder for a single WealthProxies connection string. Rotating omits the session token.
export function buildProxyLine({ host, port, username, password, proxyType, sessionType, poolToken, geo }) {
  const token = proxyType === "rotating" ? "" : `-${SESSION_PREFIX[sessionType]}${hexId()}`;
  return `${host}:${port}:${username}:${password}${token}-${poolToken}-${geo}`;
}

export const CHART_MARGIN = { top: 6, right: 4, left: 4, bottom: 0 };
export const CHART_TICK = { fontSize: 9, fill: "#9CA3AF" };
export const CHART_CURSOR = { fill: "#E7F7F4" };
export const CHART_TOOLTIP_STYLE = { borderRadius: 10, border: "1px solid #E4EEEC", fontSize: 12 };
export const CHART_BAR_RADIUS = [4, 4, 0, 0];
export const usageFmt = (v) => [`${v} GB`, "Usage"];

export function parseRemaining(remote) {
  if (!remote) return null;
  const d = remote.data || remote;
  // Live WealthProxies API returns bandwidthAvailableGb; keep other keys as fallbacks.
  return d.bandwidthAvailableGb ?? d.remainingBandwidth ?? d.bandwidthRemaining ?? d.remaining ?? d.bandwidth ?? null;
}
